import(/* webpackMode: "eager" */ "/app/hub/src/app/error.tsx");
